import { call, put, takeEvery } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { push } from 'redux-router';
import validator from 'services/validator.js';
import constants from 'constants';
import actions from 'actions';
import axios from 'axios';

const {
  addAdminUsersWebinars,
  addRequestError
} = actions;

const {
  LOAD_ADMIN_USRES_WEBINARS_SAGA,
  API_WEBINARS_USERS
} = constants;

const apiLoadAdminUsersWebinars = (id) => (
  axios.get(`${API_WEBINARS_USERS}/${id}`)
);

function* loadAdminUsersWebinars({ webinarId }) {
  try {
    const response = yield call(apiLoadAdminUsersWebinars, webinarId);
    const users = response.data.users;
    yield put(addAdminUsersWebinars(users));

  } catch (e) {
    console.log(e);
    yield put(addRequestError(e.response))
  }
}


function* __loadAdminUsersWebinars() {
  yield takeEvery(LOAD_ADMIN_USRES_WEBINARS_SAGA, loadAdminUsersWebinars)
}

export {
  __loadAdminUsersWebinars,
};



/** WEBPACK FOOTER **
 ** ./src/sagas/admin/webinars.js
 **/